export { sendErrorInErrorToGA, gaSendEvent, sendErrorToGA } from './ga';
